import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { OpenIDConnectService } from '@services/auth/openid-connect.service';

@Injectable({ providedIn: 'root' })
export class AuthGuardService implements CanActivate {
  constructor(private readonly auth: OpenIDConnectService) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.auth.userAvailable && !this.auth.user.expired) {
      return true;
    } else {
      this.auth.triggerSignIn();
      return false;
    }
  }
}
